import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import BuildSelectorContainer from './../Containers/BuildSelectorContainer';
import BuildViewerContainer from './../Containers/BuildViewerContainer';
import ConditionalComponent from './ConditionalComponent';

const BuildComponent = ({ isAuthenticated, releaseBuildPresent }) => (
  <div>
    <ConditionalComponent condition={!isAuthenticated}>
      <center>
        <p style={{ color:'orange' }}>
          Build gauges may behave differently and feedback comments cannot
          be added if not logged in with JIRA credentials.
        </p>
      </center>
    </ConditionalComponent>
    <ConditionalComponent condition={!releaseBuildPresent}>
      <center>
        <p style={{ color:'red' }}>
          No release build found within last 60 days; page may be
          unstable and contents inaccurate.
        </p>
      </center>
    </ConditionalComponent>
    <Row>
      <Col sm={12} md={8} mdOffset={2}>
        <Row style={{ marginBottom: '15px' }}>
          <Col xs={12}>
            <BuildSelectorContainer />
          </Col>
        </Row>
        <BuildViewerContainer />
      </Col>
    </Row>
  </div>
);

BuildComponent.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  releaseBuildPresent: PropTypes.bool.isRequired
};

export default BuildComponent;


// WEBPACK FOOTER //
// src/Components/BuildComponent.jsx